import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto px-2 sm:px-0" }
const _hoisted_2 = { class: "trezo-card w-full bg-white dark:bg-[#0c1427] p-[15px] sm:p-[20px] md:p-[25px] rounded-md" }
const _hoisted_3 = { class: "trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[15px] sm:mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[15px] sm:-mx-[20px] md:-mx-[25px] -mt-[15px] sm:-mt-[20px] md:-mt-[25px] p-[15px] sm:p-[20px] md:p-[25px] rounded-t-md" }
const _hoisted_4 = { class: "trezo-card-title" }
const _hoisted_5 = { class: "mb-0 text-base sm:text-lg md:text-xl" }
const _hoisted_6 = { class: "trezo-card-subtitle" }
const _hoisted_7 = { class: "trezo-card-content overflow-y-auto max-h-[calc(100vh-150px)] sm:max-h-[calc(100vh-180px)] pr-1" }
const _hoisted_8 = { class: "sm:grid sm:grid-cols-2 sm:gap-[20px] md:gap-[25px]" }
const _hoisted_9 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_10 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_11 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_12 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_13 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_14 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_15 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_16 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_17 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "mb-[15px] sm:mb-0" }
const _hoisted_20 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_21 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_24 = ["type", "onUpdate:modelValue", "required"]
const _hoisted_25 = ["onUpdate:modelValue", "required"]
const _hoisted_26 = ["onUpdate:modelValue", "required"]
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "sm:col-span-2 mb-[15px] sm:mb-0" }
const _hoisted_30 = { class: "mb-[8px] sm:mb-[10px] text-black dark:text-white font-medium block text-sm" }
const _hoisted_31 = { class: "mt-[15px] sm:mt-[20px] md:mt-[25px] ltr:text-right rtl:text-left" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "inline-block relative ltr:pl-[20px] sm:ltr:pl-[25px] rtl:pr-[25px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto py-[10px] sm:py-[20px]',
      { active: _ctx.stateStoreInstance.active },
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.directT('crm.leads.addNewLead')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "text-[20px] sm:text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "ri-close-fill" }, null, -1)
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveLead && _ctx.saveLead(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.directT('crm.leads.form.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newLead.name) = $event)),
                    required: "",
                    class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm",
                    placeholder: "E.g. Olivia"
                  }, null, 512), [
                    [_vModelText, _ctx.newLead.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.directT('crm.leads.form.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newLead.email) = $event)),
                    required: "",
                    class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm",
                    placeholder: "E.g. olivia@clickai.live"
                  }, null, 512), [
                    [_vModelText, _ctx.newLead.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.directT('crm.leads.form.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newLead.phone) = $event)),
                    class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm",
                    placeholder: "E.g. +023-244-1234"
                  }, null, 512), [
                    [_vModelText, _ctx.newLead.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.directT('crm.leads.form.leadSource')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newLead.source) = $event)),
                    required: "",
                    class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                  }, [
                    _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.directT('crm.leads.form.select')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sources, (source) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: source.name,
                        value: source.name
                      }, _toDisplayString(source.name), 9, _hoisted_18))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newLead.source]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.directT('crm.leads.form.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newLead.status) = $event)),
                    required: "",
                    class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                  }, [
                    _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.directT('crm.leads.form.select')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: status.name,
                        value: status.name
                      }, _toDisplayString(status.name), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newLead.status]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customFields.filter(f => f.required), (field) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: field.key,
                    class: _normalizeClass(["mb-[15px] sm:mb-0", {'sm:col-span-2': field.type === 'textarea'}])
                  }, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(field.label) + " " + _toDisplayString(field.required ? '*' : ''), 1),
                    (_ctx.getInputType(field.type) !== 'select' && field.type !== 'textarea')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: _ctx.getInputType(field.type),
                          "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                          required: field.required,
                          class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                        }, null, 8, _hoisted_24)), [
                          [_vModelDynamic, _ctx.customFieldValues[field.key]]
                        ])
                      : (field.type === 'textarea')
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 1,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                            required: field.required,
                            rows: "3",
                            class: "rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] py-[10px] sm:py-[12px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm"
                          }, null, 8, _hoisted_25)), [
                            [_vModelText, _ctx.customFieldValues[field.key]]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 2,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.customFieldValues[field.key]) = $event),
                            required: field.required,
                            class: "h-[45px] sm:h-[50px] md:h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[12px] sm:px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500 text-sm"
                          }, [
                            _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.directT('crm.leads.form.select')), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option,
                                value: option
                              }, _toDisplayString(option), 9, _hoisted_28))
                            }), 128))
                          ], 8, _hoisted_26)), [
                            [_vModelSelect, _ctx.customFieldValues[field.key]]
                          ])
                  ], 2))
                }), 128)),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.directT('crm.leads.form.notes')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newLead.notes) = $event)),
                    rows: "3",
                    class: "rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[15px] sm:px-[17px] py-[10px] sm:py-[12px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500 text-sm",
                    placeholder: "Add notes about this lead..."
                  }, null, 512), [
                    [_vModelText, _ctx.newLead.notes]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "rounded-md inline-block transition-all font-medium ltr:mr-[10px] sm:ltr:mr-[15px] rtl:ml-[15px] px-[20px] sm:px-[26.5px] py-[10px] sm:py-[12px] bg-danger-500 text-white hover:bg-danger-400 text-sm",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
                }, _toDisplayString(_ctx.directT('crm.leads.form.cancel')), 1),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.loading,
                  class: "inline-block bg-primary-500 text-white py-[10px] sm:py-[12px] px-[20px] sm:px-[26.5px] transition-all rounded-md hover:bg-primary-400 disabled:opacity-70 disabled:cursor-not-allowed text-sm"
                }, [
                  _createElementVNode("span", _hoisted_33, [
                    _cache[11] || (_cache[11] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] sm:!text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2" }, " add ", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.loading ? _ctx.directT('crm.leads.form.creating') : _ctx.directT('crm.leads.form.create')), 1)
                  ])
                ], 8, _hoisted_32)
              ])
            ], 32)
          ])
        ])
      ])
    ], 2),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md p-4 rounded-md shadow-lg transform transition-transform duration-300 z-50 flex items-center justify-between", { 
      'bg-green-600 text-white': _ctx.toastType === 'success', 
      'bg-red-600 text-white': _ctx.toastType === 'error', 
      'bg-blue-600 text-white': _ctx.toastType === 'info' 
    }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.toastMessage), 1),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
            class: "ml-4 text-white hover:text-gray-300"
          }, "×")
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}